import { Component, ViewEncapsulation } from '@angular/core';
import { PRICE_UP_TO_2500 } from '@config/error-messages.const';
import ElectronicsLandingBase from '../electronics-landing-base.component';
import { TableData } from '@models/table-data';
import { insuranceComparison } from '../../config/insurance-comparison';
import { handyBenefitsTable } from '../../config/handy-benefits-table';
import { ReactiveFormsModule } from '@angular/forms';
import { CtrlErrorMessageDirective } from '@co-3/ctrl-ui/forms';
import { PriceDisplayCardComponent } from 'app/order/components/price-display-card/price-display-card.component';
import { CollapsibleTableComponent } from 'app/shared/components/collapsible-table/collapsible-table.component';
import { InfoTooltipComponent } from 'app/shared/components/info-tooltip/info-tooltip.component';
import { VariantsFieldsetComponent } from '../../components/variants-fieldset/variants-fieldset.component';
import { FaqHandyComponent } from '../../components/faq-handy/faq-handy.component';
import { PriceInputDirective } from 'app/shared/directives/price-input.directive';
import { SuspendEnterDirective } from 'app/shared/directives/suspend-enter.directive';

@Component({
    selector: 'app-handy-landing',
    templateUrl: './handy-landing.component.html',
    styleUrl: './handy-landing.component.scss',
    encapsulation: ViewEncapsulation.None,
    imports: [
        ReactiveFormsModule,
        InfoTooltipComponent,
        CtrlErrorMessageDirective,
        VariantsFieldsetComponent,
        PriceDisplayCardComponent,
        CollapsibleTableComponent,
        FaqHandyComponent,
        PriceInputDirective,
        SuspendEnterDirective,
    ],
})
export class HandyLandingComponent extends ElectronicsLandingBase {
    public insuranceComparison: TableData = insuranceComparison;
    public handyBenefits: TableData = handyBenefitsTable;
    public valueErrorMessage: string = PRICE_UP_TO_2500;

    public constructor() {
        super();
        this.initForm('Smartphone');
    }

    public submit(): void {
        this.next.emit(this.getData());
    }
}
